<template>
  <div>
    <div id="myCal">
      <div v-if='addPlanBol'>
        <a-form :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
          <div class="title_">
            <div class="cutleft_">保费试算</div>
            <div class="cutoff_"></div>
          </div>
          <div class="risk_">
            <div class="form_item">
              <label>计划名称</label>
              <div class="right_">
                <a-input class="right_input" :disabled="true" v-model="countData.planName"
                  @change="(value) => changeData(value.target.value, 'planName')"></a-input>
              </div>
            </div>
            <div class="form_item">
              <label>保障期限</label>
              <div class="right_">
                <div style="width:300px">1年</div>
              </div>
            </div>
            <div class="form_item">
              <label>投保职业</label>
              <div class="right_">
                <div class="check_item s_input" v-for="item in numberLIst" :key="item.oKind">
                  <label for>{{ item.oKind }}</label>
                  <a-input-number :disabled="disabledAll" :min="0" v-model="item.pNum"
                    @change="(value) => changeData(value, 'numberLIst')"></a-input-number>
                  <span>人</span>
                </div>
                <div class="check_item">
                  <span>总人数：{{ totalNumber }}人</span>
                </div>
              </div>
            </div>
            <div>
              <a href="/files/FXTY/职业类别表.xlsx" download>职业类别表</a>
            </div>
            <div class="form_item">
              <label>是否涉高&nbsp;&nbsp;&nbsp;</label>
              <div class="right_">
                <div style="width:300px">
                  <a-radio-group name="radioGroup" :default-value="2" :disabled="disabledAll||firstPlan"
                    v-model="countData.SFSGa" @change="(e) => changeData(e.target.value, 'SFSGa')">
                    <a-radio :value="2">不涉高</a-radio>
                    <a-radio :value="1">涉高</a-radio>
                  </a-radio-group>
                </div>
                <div style="font-style:normal;color: red;font-size:12px;width: 100%;">*该责任整张保单统一一个标准*</div>
              </div>
            </div>
            <p class="p-header">主险</p>
            <!-- 工伤死亡伤残 -->
            <div class="form_item">
              <label>意外身故、残疾</label>
              <div class="right_">
                <a-select placeholder="请选择" style="width: 300px" :disabled="disabledAll" class="select_"
                  @change="(value) => changeData(value, 'YWSG')" v-model="countData.YWSG">
                  <a-select-option v-for="item in YWSGOptions" :key="item.value + 'YWSG'" :value="item.value">
                    {{ item.name }}</a-select-option>
                </a-select>
              </div>
            </div>
            <!-- 伤残评定标准 -->
            <div class="form_item">
              <label>伤残评定标准</label>
              <div class="right_">
                <a-select placeholder="请选择" style="width: 300px" :disabled="disabledAll||(numberLIst[5]&&numberLIst[5].pNum>0)" class="select_"
                  @change="(value) => changeData(value, 'SCPD')" v-model="countData.SCPD">
                  <a-select-option v-for="item in SCPDOptions" :key="item.value + 'SCPD'" :value="item.value">
                    {{ item.name }}</a-select-option>
                </a-select>
              </div>
            </div>
            <p class="p-header">附加险</p>
            <!-- 意外医疗费用（0免赔100%赔付 -->
            <div class="form_item">
              <label>意外医疗费用（0免赔100%赔付）</label>
              <div class="right_">
                <a-select :disabled="disabledAll" placeholder="请选择" style="width: 300px" class="select_"
                  v-model="countData.YWYL" @change="(value) => changeData(value, 'YWYL')">
                  <a-select-option v-for="(item, index) in YWYLOptions" :key="item.value + 'YWYL' + index"
                    :value="item.value">{{ item.name }}</a-select-option>
                </a-select>
              </div>
            </div>
            <!-- 意外医疗费用免赔额 -->
            <div class="form_item">
              <label>意外医疗费用免赔额</label>
              <div class="right_">
                <a-select placeholder="请选择" style="width: 300px" class="select_"
                  :disabled="countData.YWYL === 0||disabledAll" v-model="countData.YWYLMP"
                  @change="(value) => changeData(value, 'YWYLMP')">
                  <a-select-option v-for="(item, index) in YWYLMPOptions" :key="item.value + 'YWYLMP' + index"
                    :value="item.value">{{ item.name }}</a-select-option>
                </a-select>
              </div>
            </div>
            <!-- 意外医疗费用赔付范围 -->
            <div class="form_item">
              <label>意外医疗费用赔付范围</label>
              <div class="right_">
                <a-select placeholder="请选择" style="width: 300px" class="select_"
                  :disabled="countData.YWYL === 0||disabledAll" v-model="countData.YWYLPF"
                  @change="(value) => changeData(value, 'YWYLPF')">
                  <a-select-option v-for="item in YWYLPFOptions" :key="item.value + 'YWYLPF'" :value="item.value">
                    {{ item.name }}</a-select-option>
                </a-select>
              </div>
            </div>
            <!--意外住院津贴 -->
            <div class="form_item">
              <label>意外住院津贴</label>
              <div class="right_">
                <a-select placeholder="请选择" style="width: 300px" class="select_" :disabled="disabledAll"
                  v-model="countData.ZYJT" @change="(value) => changeData(value, 'ZYJT')">
                  <a-select-option v-for="item in ZYJTOptions" :key="item.value + 'ZYJT'" :value="item.value">
                    {{ item.name }}</a-select-option>
                </a-select>
              </div>
            </div>
            <!-- 营运交通意外伤害（本保障项下航空意外为必选） -->
            <div class="form_item">
              <label>营运交通意外伤害（本保障项下航空意外为必选）</label>
              <div class="right_">
                <a-select placeholder="请选择" :disabled="disabledAll" style="width: 300px" class="select_"
                  v-model="countData.YYJTYW" @change="(value) => changeData(value, 'YYJTYW')">
                  <a-select-option value="0">不附加</a-select-option>
                  <a-select-option value="1">附加</a-select-option>
                </a-select>
              </div>
            </div>
            <!-- 航空意外伤害 -->
            <div class="form_item">
              <label>航空意外伤害</label>
              <div class="right_">
                <a-select placeholder="请选择" style="width: 300px" :disabled="countData.YYJTYW == 0||disabledAll"
                  class="select_" v-model="countData.HKYW" @change="(value) => changeData(value, 'HKYW')">
                  <a-select-option v-for="item in HKYWOptions" :key="item.value + 'HKYW'" :value="item.value">
                    {{ item.name }}</a-select-option>
                </a-select>
              </div>
            </div>
            <!-- 轨道意外伤害 -->
            <div class="form_item">
              <label>轨道意外伤害</label>
              <div class="right_">
                <a-select placeholder="请选择" style="width: 300px" :disabled="countData.YYJTYW == 0||disabledAll"
                  class="select_" v-model="countData.GDJTYW" @change="(value) => changeData(value, 'GDJTYW')">
                  <a-select-option v-for="item in GDJTYWOptions" :key="item.value + 'GDJTYW'" :value="item.value">
                    {{ item.name }}</a-select-option>
                </a-select>
              </div>
            </div>
            <!-- 轮船意外伤害 -->
            <div class="form_item">
              <label>轮船意外伤害</label>
              <div class="right_">
                <a-select placeholder="请选择" style="width: 300px" :disabled="countData.YYJTYW == 0||disabledAll"
                  class="select_" v-model="countData.LCJTYW" @change="(value) => changeData(value, 'LCJTYW')">
                  <a-select-option v-for="item in LCJTYWOptions" :key="item.value + 'LCJTYW'" :value="item.value">
                    {{ item.name }}</a-select-option>
                </a-select>
              </div>
            </div>
            <!-- 营运汽车意外伤害 -->
            <div class="form_item">
              <label>营运汽车意外伤害</label>
              <div class="right_">
                <a-select placeholder="请选择" style="width: 300px" :disabled="countData.YYJTYW == 0||disabledAll"
                  class="select_" v-model="countData.YYQCYW" @change="(value) => changeData(value, 'YYQCYW')">
                  <a-select-option v-for="item in YYKCYWOptions" :key="item.value + 'YYQCYW'" :value="item.value">
                    {{ item.name }}</a-select-option>
                </a-select>
              </div>
            </div>
            <!-- 猝死 -->
            <div class="form_item">
              <label>猝死</label>
              <div class="right_">
                <a-select placeholder="请选择" style="width: 300px" :disabled="disabledAll||firstPlan" class="select_"
                  v-model="countData.CS" @change="(value) => changeData(value, 'CS')">
                  <a-select-option v-for="item in CSOptions" :key="item.value + 'CS'" :value="item.value">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
                <div style="font-style:normal;color: red;font-size:12px;width: 100%;">*该责任整张保单统一一个标准*</div>
              </div>
            </div>
          </div>
          <div class="btn_list">
            <a-button class="calBtn_" type="primary" @click="countPremiumSum" :disabled="disabledAll">刷新试算</a-button>
            <label>总保费：</label>
            <a-input style="width: 300px;" class="right_input" readonly="readonly" v-model="totalPremium"></a-input>
          </div>
          <div class="btn_list">
            <a-button class="calBtn_" type="primary" @click="savePlan" :disabled="disabledAll">保存计划</a-button>
            <a-button class="calBtn_" type="primary" @click="addPlanBol = false">返回</a-button>
          </div>
        </a-form>
        <div class="title_">
          <div class="cutoff_"></div>
        </div>
      </div>
    </div>
    <div class="btn_list">
      <a-button class="calBtn_" type="primary" v-if='!disabledAll&&!addPlanBol' @click="addPlan">
        新增计划</a-button>
    </div>
    <a-table style="margin:10px auto;" :columns="columns" :data-source="planList">
      <template slot="do" slot-scope="record">
        <a @click="editPlan(record)">编辑</a>
        <a style="margin-left: 10px" @click="deletePlan(record)">删除</a>
      </template>
    </a-table>

    <a-button style="margin-bottom:50px;" class="calBtn_" type="primary" @click="goplicy" v-if='!agreementRead'>
      完成报价，立即投保</a-button>
  </div>
</template>

<script>
  const columns = [
    {
      title: "计划名称",
      dataIndex: "planName",
      key: "name"
    },
    {
      title: "投保人数",
      dataIndex: "totalNumber",
      key: "totalNumber"
    },
    {
      title: "计划保费",
      dataIndex: "totalPremium",
      key: "totalPremium"
    },
    {
      title: "操作",
      key: "do",
      scopedSlots: { customRender: "do" }
    }
  ];
  import { riskinfoMixin } from '@/mixins/riskinfoMixin.js';
let DATA = require('../data').default;
  export default {
  mixins: [riskinfoMixin],
    data() {
      return {
        columns,
        addPlanShow: true,
        planList: [],
        form: this.$form.createForm(this, { name: "advanced_search" }),
        guapre: 12,
        planKey: 0,
        //投保职业及人数
        numberLIst: DATA.numberLIst,
        premiumSum: 0, //总保费
        SCPDOptions: DATA.SCPDOptions,
        YWYLPFOptions: [
          //意外医疗赔付范围
          {
            value: 1,
            name: "仅社保范围内"
          },
          {
            value: 2.5,
            name: "扩展乙丙自费药"
          }
        ],
        // 附加24小时意外扩展条款
        KZSCOptions: [
          {
            value: 0,
            name: "不附加"
          },
          {
            value: 1,
            name: "附加"
          }
        ],
        // 工伤伤残赔付高标准（附加提升伤残比例）
        oneSCOptions: [
          {
            value: 0,
            name: "不附加"
          },
          {
            value: 1,
            name: "附加"
          }
        ],

        //轨道交通意外
        GDJTYWOptions: DATA.GDJTYWOptions,
        //轮船意外
        LCJTYWOptions: DATA.LCJTYWOptions,
        //营运车辆意外
        YYKCYWOptions: DATA.YYKCYWOptions,
        // 测算要提交的数据
        countData: {
          YYJTYW: "0", //营业交通意外
          SCPD: 1, //伤残标准
          SFSGa: 2, //是否涉高
          YWYL: 0,
          planName: "",
          CS: 0,
          YWSG: 100000 //工伤死亡伤残
        },
        totalPremium: 0,
        //提交data
        data: {
          riskInfos: []
        },
        addPlanBol: false,
        planType: "A",
        creator: "1",
        productCode: "",
        plan: "",
        userParams: ""
      };
    },
    computed: {
      // 猝死
      CSOptions() {
        let Options = [
          //猝死赔付
          {
            value: 0,
            name: "不附加"
          },
          {
            value: 50000,
            name: "5万"
          },
          {
            value: 100000,
            name: "10万"
          },
          {
            value: 200000,
            name: "20万"
          }
        ]
        return Options.filter(item => item.value <= this.countData.YWSG);
      },
      // 计划顶部标识
      firstPlan() {
        let key = this.countData.key
        let length = this.planList.filter(item => item.key < key).length
        return length == 0 ? false : true
      },
      // 意外身故
      YWSGOptions() {
        let Options = [
          {
            value: 100000,
            name: "10万"
          },
          {
            value: 200000,
            name: "20万"
          },
          {
            value: 300000,
            name: "30万"
          },
          {
            value: 400000,
            name: "40万"
          },
          {
            value: 500000,
            name: "50万"
          },
          {
            value: 600000,
            name: "60万"
          },
          {
            value: 700000,
            name: "70万"
          },
          {
            value: 800000,
            name: "80万"
          },
          {
            value: 900000,
            name: "90万"
          },
          {
            value: 1000000,
            name: "100万"
          }
        ];
        if (this.numberLIst[2].pNum || this.numberLIst[3].pNum || this.numberLIst[4].pNum) {
          if (this.countData.YWSG > 600000) {
            this.countData.YWSG = 100000
          }
          Options = Options.filter(item => item.value <= 600000);
        }
        if (this.numberLIst[5].pNum) {
          if (this.countData.YWSG > 400000) {
            this.countData.YWSG = 100000
          }
          this.countData.SCPD = 1
          Options = Options.filter(item => item.value <= 400000);
        }
        return Options;
      },
      YWYLMPOptions() {
        // 意外医疗免赔
        let Options = [
          //
          {
            value: 0,
            name: "不附加"
          },
          {
            value: 50,
            name: "50元/天"
          },
          {
            value: 100,
            name: "100元/天"
          },
          {
            value: 200,
            name: "200元/天"
          }
        ];
        return Options;
      },
      // 航空交通意外
      HKYWOptions() {
        let Options = [
          {
            value: 0,
            name: "不附加"
          },
          {
            value: 100000,
            name: "10万"
          },
          {
            value: 200000,
            name: "20万"
          },
          {
            value: 300000,
            name: "30万"
          },
          {
            value: 400000,
            name: "40万"
          },
          {
            value: 500000,
            name: "50万"
          },
          {
            value: 600000,
            name: "60万"
          },
          {
            value: 700000,
            name: "70万"
          },
          {
            value: 800000,
            name: "80万"
          },
          {
            value: 900000,
            name: "90万"
          },
          {
            value: 1000000,
            name: "100万"
          }
        ];
        if (this.countData.YYJTYW > 0) {
          return Options.filter(item => item.value > 0);
        } else {
          return Options;
        }
      },
      // 工伤事故医疗费用（0免赔100%赔付）
      YWYLOptions() {
        let YWSG = this.countData.YWSG
        let option = [
          {
            value: 0,
            name: "0"
          },
          {
            value: 10000,
            name: "1万"
          },
          {
            value: 20000,
            name: "2万"
          },
          {
            value: 30000,
            name: "3万"
          },
          {
            value: 40000,
            name: "4万"
          },
          {
            value: 50000,
            name: "5万"
          },
          {
            value: 60000,
            name: "6万"
          },
          {
            value: 70000,
            name: "7万"
          },
          {
            value: 80000,
            name: "8万"
          },
          {
            value: 90000,
            name: "9万"
          },
          {
            value: 100000,
            name: "10万"
          }
        ];
        return option.filter(item => item.value <= YWSG * 0.2);
      },
      // 住院津贴
      ZYJTOptions() {
        let ZYJTOptions = [
          {
            value: 0,
            name: "0"
          },
          {
            value: 50,
            name: "50元"
          },
          {
            value: 100,
            name: "100元"
          },
          {
            value: 150,
            name: "150元"
          },
          {
            value: 200,
            name: "200元"
          }
        ];
        return ZYJTOptions;
      },
      // 选的总投保人数
      totalNumber() {
        let num = 0;
        this.numberLIst.forEach(e => {
          num += e.pNum;
        });
        return parseInt(num);
      },
      // 险种的数组
      riskInfos() {
        let infos = [
          {
            riskCode: "210004", //意外身故、残疾
            dutyCode: "210034",
            amount: this.countData.YWSG,
            premiumAmt: 0,
            riskName: `意外身故、残疾`,
            riskAmountDesc: this.countData.YWSG,
            planCode: this.countData.planName
          },
          {
            riskCode: "210004", //伤残评定标准
            dutyCode: "210034SC",
            amount: this.countData.SCPD,
            premiumAmt: 0,
            riskName: `伤残评定标准`,
            riskAmountDesc: this.countData.SCPD,
            planCode: this.countData.planName
          },
          {
            riskCode: "220001", //意外医疗费用(0免赔100%赔付)
            dutyCode: "220040FY",
            amount: this.countData.YWYL,
            premiumAmt: 0,
            riskName: `意外医疗费用(0免赔100%赔付)`,
            riskAmountDesc: this.countData.YWYL,
            planCode: this.countData.planName
          },
          {
            riskCode: "220001", //意外医疗费用免赔额
            dutyCode: "220040MP",
            amount: this.countData.YWYLMP,
            premiumAmt: 0,
            riskName: `意外医疗费用免赔额`,
            riskAmountDesc: `${this.countData.YWYLMP}元/天`,
            planCode: this.countData.planName
          },
          {
            riskCode: "220001", //意外医疗费用赔付范围
            dutyCode: "220040FW",
            amount: this.countData.YWYLPF,
            premiumAmt: 0,
            riskName: `意外医疗费用赔付范围`,
            riskAmountDesc: "仅社保范围内",
            planCode: this.countData.planName
          },
          {
            riskCode: "220002", //意外住院津贴
            dutyCode: "220400",
            amount: this.countData.ZYJT,
            premiumAmt: 0,
            riskName: `意外住院津贴`,
            riskAmountDesc: `${this.countData.ZYJT}元/天`,
            planCode: this.countData.planName
          },
          {
            riskCode: "210005", //营运交通意外伤害
            dutyCode: "210005",
            amount: this.countData.YYJTYW,
            premiumAmt: 0,
            riskName: `营运交通意外伤害`,
            riskAmountDesc: this.countData.YYJTYW,
            planCode: this.countData.planName
          },
          {
            riskCode: "210005", //航空意外伤害
            dutyCode: "210605",
            amount: this.countData.HKYW,
            premiumAmt: 0,
            riskName: `航空意外伤害`,
            riskAmountDesc: this.countData.HKYW,
            planCode: this.countData.planName
          },
          {
            riskCode: "210005", //轨道意外伤害
            dutyCode: "210606",
            amount: this.countData.GDJTYW,
            premiumAmt: 0,
            riskName: `轨道意外伤害`,
            riskAmountDesc: this.countData.GDJTYW,
            planCode: this.countData.planName
          },
          {
            riskCode: "210005", //轮船意外伤害
            dutyCode: "210607",
            amount: this.countData.LCJTYW,
            premiumAmt: 0,
            riskName: `轮船意外伤害`,
            riskAmountDesc: this.countData.LCJTYW,
            planCode: this.countData.planName
          },
          {
            riskCode: "210005", //营运汽车意外伤害
            dutyCode: "210608",
            amount: this.countData.YYQCYW,
            premiumAmt: 0,
            riskName: `营运汽车意外伤害`,
            riskAmountDesc: this.countData.YYQCYW,
            planCode: this.countData.planName
          },
          {
            riskCode: "210004", //猝死
            dutyCode: "210034CS",
            amount: this.countData.CS,
            premiumAmt: 0,
            riskName: `猝死`,
            riskAmountDesc: this.countData.CS,
            planCode: this.countData.planName
          }
        ];
        return infos;
      }
    },
    watch: {
      "countData.YLFY"(val) {
        if (!val) {
          this.countData.ZFYF = 0;
        }
      },
      planList: {
        handler: function (val) {
          this.$bus.$emit("onRiskInfos", val);
        },
        deep: true
      },
    },
    props: ["disabledAll"],
    created() {
      const { u, p } = this.$route.query;
      this.creator = u;
      this.productCode = p;
      this.plan = p;
      this.userParams = {
        //从地址中获取
        userId: u,
        productCode: p
      };
    },
    mounted() {
      this.$bus.$on("busPlaninfos", (data, list) => {
        this.planKey = data.length
        data.forEach(element => {
          let riskInfos = list.filter(item => item.planCode == element.planName)
          element.riskInfos = riskInfos
        })
        this.planList = data
      });
      this.$bus.$on("salPolicyExt", data => {
        this.countData.SFSGa = Number(data.isworkheightinvolved) || 2;
      });
      this.$bus.$on("addPremiumBlur", (data) => {
        if (data >= 0 && this.planList.length > 0) {
          this.planList.forEach(elemnt => {
            this.addPremiumApi(elemnt, data)
          })
        }
      })
    },
    beforeDestroy() {
      this.$bus.$off("busRiskInfos");
      this.$bus.$off("salPolicyExt");
      this.$bus.$off("addPremiumBlur");
    },
    methods: {
      addPlan() {
        if (this.planList.length == 1) {
          this.$message.warning("最多可以录入一个计划！", 1);
          return
        }
        this.addPlanBol = true
        this.planKey = this.planKey + 1
        this.countData.key = this.planKey
        let item = this.planList[0] || {}
        this.countData.planName = `计划${this.countData.key}`
        this.countData.SFSGa = item.SFSGa
        let riskInfo = this.riskInfo(item.riskInfos || [])
        this.countData.CS = riskInfo.CS
      },
      // 去投保
      goplicy() {
        this.$store.commit('setAgreement', true)
      },
      // 改变试算的数据
      changeData(value, param) {
        if (param == 'YWSG') {
          this.countData.YWYL = 10000
        }
        if (param == 'SFSGa') {
          this.planList.forEach(item => {
            item.SFSGa = value
          })
          this.$bus.$emit('addPremiumBlur', 0)
        }
        if (param == 'CS') {
          this.planList.forEach(item => {
            if (item.riskInfos.length > 0) {
              let index = item.riskInfos.findIndex(item => item.dutyCode == "210034CS")
              if (index == '-1') {
                let obj = {
                  riskCode: "210004", //猝死
                  dutyCode: "210034CS",
                  amount: value,
                  premiumAmt: 0,
                  riskName: `猝死`,
                  riskAmountDesc: value,
                  planCode: item.planName
                }
                item.riskInfos.push(obj)
              } else {
                item.riskInfos[index].amount = value
                item.riskInfos[index].riskAmountDesc = value
              }
            }
          })
          this.$bus.$emit('addPremiumBlur', 0)
        }
        if (param == "YYJTYW" && value == 0) {
          this.countData.HKYW = 0;
          this.countData.GDJTYW = 0;
          this.countData.LCJTYW = 0;
          this.countData.YYQCYW = 0;
        }
        if (param == "YYJTYW" && value != 0) {
          this.$set(this.countData, 'HKYW', 100000)
        }

        if (param == "YWYL" && value == 0) {
          this.countData.YWYLMP = 0;
          this.countData.YWYLPF = 1;
        }
        this.countData[param] = value
        this.$set(this.countData, param, value)
        this.data = {
          riskInfos: this.riskInfos.filter(item => item.amount&& item.amount!= 0), //险种信息
          salPolicy: {
            planCode: this.plan,
            creator: this.creator,
            productCode: this.productCode, //产品code
            bracket: 12 //保费期限
          }
        };
        this.countPremiumSum();
      },
      //保费试算
      countPremiumSum() {
        if (!this.countData.planName) {
          this.$message.warning("请输入计划名称", 1);
          return;
        }
        if (!this.totalNumber) {
          this.premiumSum = 0;
          return;
        }
        let formData = this.$lodash.cloneDeep(this.data);
        this.form.validateFields((err) => {
          if (!err) {
            this.$api.FXTYPremiumTrial(formData).then(res => {
              if (res.data.success) {
                this.countPlanPremium(res.data.content);
              } else {
                this.$message.error(res.data.returnMsg + "错误");
              }
            });
          }
        });
      },
      addPremiumApi(data, discountfactor) {//加费保费计算
        let formData = {
          riskInfos: data.riskInfos.filter(item => item.amount > 0), //险种信息
          salPolicy: {
            planCode: this.plan,
            creator: this.creator,
            productCode: this.productCode, //产品code
            discountfactor: discountfactor,
            bracket: 12 //保费期限
          }
        }
        this.$api.FXTYPremiumTrial(formData).then(res => {
          if (res.data.success) {
            let totalPremium = 0;
            let originalData = res.data.content
            data.numberLIst.forEach(element => {
              let pNum = parseInt(element.pNum);
              let premium = Math.round(originalData[element.oKey] * 100);
              let occupationPremium = parseInt(pNum * premium);
              totalPremium += occupationPremium;
            });
            data.occPremium = originalData;
            data.totalPremium = totalPremium / 100;
          }
        });
      },
      //计算计划总保费
      countPlanPremium(data) {
        let totalPremium = 0;
        this.numberLIst.forEach(element => {
          let pNum = parseInt(element.pNum) || 0;
          let premium = Math.round(data[element.oKey] * 100);
          let occupationPremium = pNum * premium;
          totalPremium += occupationPremium;
        });
        this.occPremium = data
        this.totalPremium = totalPremium / 100;
      },
      //保存计划
      savePlan() {
        if (!this.countData.planName) {
          this.$message.warning("请输入计划名称");
          return;
        }
        if (!this.totalNumber) {
          this.$message.warning("请选择投保人数");
          return;
        }
        let length = this.planList.filter(
          item => item.planName == this.countData.planName
        );
        if (length.length > 0 && this.countData.key == undefined) {
          this.$message.warning("计划名称重复");
          return;
        }
        if (
          this.countData.key != undefined &&
          length.length > 0 &&
          length[0].key != this.countData.key
        ) {
          this.$message.warning("计划名称重复");
          return;
        }
        let editBol = true
        let obj = {
          planName: this.countData.planName,
          totalPremium: this.totalPremium,
          totalNumber: this.totalNumber,
          SFSGa: this.countData.SFSGa,
          occPremium: this.occPremium,
          riskInfos: this.riskInfos.filter(item => item.amount&&item.amount != 0),
          numberLIst: JSON.parse(JSON.stringify(this.numberLIst)),
          key: this.countData.key
        };
        let index = this.planList.findIndex(item => item.key == this.countData.key)
        if (this.planList[index]) {
          this.$bus.$emit("editPlan", obj, val => { //判断修改计划的险种是否符合当前被保人
            if (val == true) {  //如果不符合 不能修改
              this.planList[index] = obj;
              this.$set(this.planList, index, obj);
            }else{
              editBol = false
            }
          })
        } else {
          this.planList.push(obj);
        }
        this.countData = {
          YYJTYW: "0", //营业交通意外
          SCPD: 1, //伤残标准
          SFSGa: 2, //是否涉高
          YWYL: 0,
          planName: "",
          CS: 0,
          YWSG: 100000 //工伤死亡伤残
        }
        this.numberLIst = [ //初始化数据
          {
            oKind: "1类",
            oKey: "1类",
            pNum: 0
          },
          {
            oKind: "2类",
            oKey: "2类",
            pNum: 0
          },
          {
            oKind: "3类",
            oKey: "3类",
            pNum: 0
          },
          {
            oKind: "4类",
            oKey: "4类",
            pNum: 0
          },
          {
            oKind: "5类",
            oKey: "5类",
            pNum: 0
          },
          {
            oKind: "特殊职业",
            oKey: "S类",
            pNum: 0
          }
        ];
        if(!editBol){return}
        this.totalPremium = 0
        this.addPlanBol = false
        this.countData.key = undefined;
      },
      // 险种的数组
      riskInfo(arr) {
        console.log(this.countData.YWSG)
        let countData = {
          YYJTYW: "0", //营业交通意外
          SCPD: 1, //伤残标准
          SFSGa: 2, //是否涉高
          YWYL: 0,
          YWSG: 100000 //工伤死亡伤残
        };
        arr.forEach(elemnt => {
          if (elemnt.riskCode == "210004" && elemnt.dutyCode == "210034") {
            countData.YWSG = elemnt.amount;
          } //意外身故、残疾
          if (elemnt.riskCode == "210004" && elemnt.dutyCode == "210034SC") {
            countData.SCPD = elemnt.amount;
          } //伤残评定标准
          if (elemnt.riskCode == "220001" && elemnt.dutyCode == "220040FY") {
            countData.YWYL = elemnt.amount;
          } //意外医疗费用(0免赔100%赔付)
          if (elemnt.riskCode == "220001" && elemnt.dutyCode == "220040MP") {
            countData.YWYLMP = elemnt.amount;
          } //意外医疗费用免赔额
          if (elemnt.riskCode == "220001" && elemnt.dutyCode == "220040FW") {
            countData.YWYLPF = elemnt.amount;
          } //意外医疗费用赔付范围
          if (elemnt.riskCode == "220002" && elemnt.dutyCode == "220400") {
            countData.ZYJT = elemnt.amount;
          } //意外住院津贴
          if (elemnt.riskCode == "210005" && elemnt.dutyCode == "210005") {
            countData.YYJTYW = elemnt.amount;
          } //营运交通意外伤害
          if (elemnt.riskCode == "210005" && elemnt.dutyCode == "210605") {
            countData.HKYW = elemnt.amount;
          } //航空意外伤害
          if (elemnt.riskCode == "210005" && elemnt.dutyCode == "210606") {
            countData.GDJTYW = elemnt.amount;
          } //轨道意外伤害
          if (elemnt.riskCode == "210005" && elemnt.dutyCode == "210607") {
            countData.LCJTYW = elemnt.amount;
          } //轮船意外伤害
          if (elemnt.riskCode == "210005" && elemnt.dutyCode == "210608") {
            countData.YYQCYW = elemnt.amount;
          } //营运汽车意外伤害
          if (elemnt.riskCode == "210004" && elemnt.dutyCode == "210034CS") {
            countData.CS = elemnt.amount;
          } //轨道意外伤害
        });
        return countData;
      },
      editPlan(item) {
        //编辑计划
        debugger
        this.numberLIst = item.numberLIst
        let riskInfos = this.riskInfo(item.riskInfos);
        this.countData = { ...riskInfos };
        this.countData.planName = item.planName;
        this.totalPremium = item.totalPremium;
        this.occPremium = item.occPremium;
        this.countData.totalNumber = item.totalNumber;
        this.countData.SFSGa = item.SFSGa;
        this.countData.key = item.key;
        this.addPlanBol = true
        this.$nextTick(() => { // 延时触发 YWYL
          this.countData.YWYL = riskInfos.YWYL;
        })
      },
      deletePlan(items) { //删除计划
        this.planList = this.planList.filter(
          item => item.planName != items.planName
        );
      }
    }
  };
</script>

<style lang="scss" scoped>
  .calTxt_ {
    font-size: 18px !important;
    font-weight: bold !important;
    color: #666666;
  }

  .pre-box {
    margin-top: 15px;
  }

  .form_items {
    display: flex;
    width: 100%;
    color: #333;
    margin-bottom: 10px;
  }


  .btn_list {
    margin-top: 20px;
    display: flex;
    line-height: 32px;

    .calBtn_ {
      margin-right: 30px;
    }
  }

  .flex_ {
    display: flex;
    flex-wrap: wrap;
  }

  .form_item {
    display: flex;
    justify-content: space-between;
    width: 100%;
    color: #333;

    &.width_50 {
      width: 50%;
    }

    &.width_40 {
      width: 40%;
    }

    &.width_60 {
      width: 60%;
    }

    >label {
      white-space: nowrap;
      margin-right: 10px;
      margin-top: 15px;
    }

    .left_ {
      flex: 1;

      input {
        width: 300px;
      }
    }

    .right_ {
      display: flex;
      width: 60%;
      flex-wrap: wrap;
      align-content: flex-start;

      .right_input {
        width: 300px;
      }

      .select_ {
        margin-top: 10px;
      }

      .check_item {
        display: flex;
        align-items: center;
        margin-right: 10px;
        margin-top: 10px;

        &.on {
          label {
            border-color: #fe8f2d;
          }
        }

        label {
          // border: 1px solid #d9d9d9;
          padding: 3px 10px;
          border-radius: 3px;
          margin-right: 5px;
        }

        &.s_input input {
          width: 50px;
        }

        input {
          width: 150px;
          margin-right: 5px;
        }
      }
    }
  }

  .p-header {
    width: 100%;
    margin-top: 20px;
    font-weight: bold;
    color: #333;
    font-size: 15px;
    margin-bottom: 0;
  }
</style>